import { MenuItem } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import SyncIcon from '@mui/icons-material/Sync';
import { CustomTextField, CustomSelect, CustomButton, HeaderFilterBox } from '../../common/components';
import { OVERDUE_FILTER_OPTIONS } from '../constants/anniversaryPlanConstants';

const AnniversaryPlanFilters = ({
  pendingFilters,
  onFilterChange,
  onSearch,
  onSync,
  isLoading,
  syncLoading,
}) => {
  return (
    <HeaderFilterBox>
      <CustomTextField
        label="Nº Contrato"
        name="contract_number"
        value={pendingFilters.contract_number}
        onChange={onFilterChange}
        onKeyDown={(e) => e.key === 'Enter' && onSearch()}
        sx={{ width: 180, mr: 1.5 }}
      />
      <CustomSelect
        label="Mora"
        labelId="has-overdue-label"
        id="has-overdue"
        name="has_overdue"
        value={pendingFilters.has_overdue}
        onChange={onFilterChange}
        displayEmpty
        sx={{ width: 160 }}
      >
        {OVERDUE_FILTER_OPTIONS.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </CustomSelect>
      <CustomButton
        variant="base"
        buttonIcon={SearchIcon}
        onClick={onSearch}
        disabled={isLoading}
        sx={{ ml: 1, mt: 1.5 }}
      >
        Buscar
      </CustomButton>
      <CustomButton
        variant="warning"
        buttonIcon={SyncIcon}
        isLoading={syncLoading}
        onClick={onSync}
        sx={{ ml: 1, mt: 1.5 }}
      >
        Sincronizar
      </CustomButton>
    </HeaderFilterBox>
  );
};

export default AnniversaryPlanFilters;
